module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_both_location@3x-e557d3319fe16a205de959c9162efd29.webp";